import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import htmlParser from "html-react-parser";
import "./banner.css";

export default function Header({ bannerData }) {
  return (
    <>
      <div className="bodyContainer" >
        <video
          width="100%"
          autoPlay
          muted
          loop
          playsInline
          className="desktopvideo"
        >
          <source src={bannerData.desktopVideoBannerLink} type="video/mp4" />
        </video>
        <video
          width="100%"
          autoPlay
          muted
          loop
          playsInline
          className="mobilevideo"
        >
          <source src={bannerData.mobileVideoBannerLink} type="video/mp4" />
        </video>
        <div>
          <Container>
            <Row>
              <Col sm={12} className="headersection header-d">
                <div>
                  {/* <img
                    src={bannerData.bannerLogo}
                    alt="Sun West Logo"
                    className="swmclogo"
                  /> */}
                  <h4 className="text-center highlightsheading alltextAnchorMorganXC my-0">
                    {htmlParser(bannerData.bannerHeading)}
                  </h4>
                  <p className="text-center highlightssubtext3 my-0">
                    {htmlParser(bannerData.bannerSubHeading3)}
                  </p>
                </div>
                <p className="text-center highlightssubtext my-1">
                  {htmlParser(bannerData.bannerSubHeading1)}
                </p>
                <p className="text-center highlightssubtext1 alltextAnchorMorgan">
                  {htmlParser(bannerData.bannerSubHeading2)}
                </p>
              </Col>
              <Col sm={12} className="headermobsection header-dm">
                <div>
                  {/* <img
                    src={bannerData.bannerLogo}
                    alt="Sun West Logo"
                    className="swmcmoblogo"
                  /> */}
                  <h4 className="text-center highlightsmobheading alltextAnchorMorganXC my-0">
                    {htmlParser(bannerData.bannermobHeading)}
                  </h4>
                  <p className="text-center highlightsmobsubtext3 my-0">
                    {htmlParser(bannerData.bannermobSubHeading3)}
                  </p>
                </div>
                
              </Col>
              <p className="text-center highlightsmobsubtext">
                  {htmlParser(bannerData.bannerSubHeading1)}
                </p>
                <p className="text-center highlightsmobsubtext1 alltextAnchorMorgan">
                  {htmlParser(bannerData.bannerSubHeading2)}
                </p>
            </Row>
          </Container>
        </div>
        {/* <a href="#contactus">
            <video width="100%" autoPlay muted loop className="mobilevideo mb-5">
              <source src={Mobilevideo} type="video/webm"></source>
            </video> 
            </a> */}
      </div>
    </>
  );
}
